export default __webpack_public_path__ + "static/media/pdf-icon.7374e011.png";